import React, { useEffect, useState } from "react";
import "./Product_Listing_Page.css";
import All_Vegitables_category_slider from "./all_vegitables_category_slider/All_Vegitables_Category_Slider";

import { Nav, Tab } from "react-bootstrap";
import Top_Filter_Div from "./top_filter_div/Top_Filter_Div";
import Product_Info_Grid_View from "../common_components/product_info_grid_view/Product_Info_Grid_View";
import Shop_Banner from "../shop/shop_banner/Shop_Banner";
import Product_Info_List_View from "../common_components/product_info_list_view/Product_Info_List_View";
import { useDispatch, useSelector } from "react-redux";
import { getAllCategories } from "../../features/master/masterSlice";
import { getAllProducts } from "../../features/products/productsSlice";
import { useLocation, useParams } from "react-router-dom";
import All_Vegitables_subCategory_Slider from "./all_vegitables_category_slider/All_Vegitables_subCategory_Slider";

const Product_Listing_Page_SubCategory = () => {
  const products = [
    {
      product_name: "Nescafe Classic",
      img: "/assets/images/products/img6.png",
      sub_text: "Price per kg",
      rating: "4.5",
      selling_price: "₹ 120.00",
      mrp: "₹ 150.00",

      discount: "10",
      outOfStock: false,
      company: "Nescafe",
    },

    {
      product_name: "Nescafe Classic",
      img: "/assets/images/products/img6.png",
      sub_text: "Price per kg",
      rating: "4.5",
      selling_price: "₹ 120.00",
      mrp: "₹ 150.00",
      discount: "10",
      outOfStock: true,
      company: "Kellog's",
    },

    {
      product_name: "Nescafe Classic",
      img: "/assets/images/products/img6.png",
      sub_text: "Price per kg",
      rating: "4.5",
      selling_price: "₹ 120.00",
      mrp: "₹ 150.00",
      discount: "10",
      outOfStock: false,
    },

    {
      product_name: "Nescafe Classic",
      img: "/assets/images/products/img6.png",
      sub_text: "Price per kg",
      rating: "4.5",
      selling_price: "₹ 120.00",
      mrp: "₹ 150.00",
      discount: "10",
      outOfStock: false,
    },

    {
      product_name: "Nescafe Classic",
      img: "/assets/images/products/img6.png",
      sub_text: "Price per kg",
      rating: "4.5",
      selling_price: "₹ 120.00",
      mrp: "₹ 150.00",
      discount: "10",
      outOfStock: false,
    },

    {
      product_name: "Nescafe Classic",
      img: "/assets/images/products/img6.png",
      sub_text: "Price per kg",
      rating: "4.5",
      selling_price: "₹ 120.00",
      mrp: "₹ 150.00",
      discount: "10",
      outOfStock: false,
    },

    {
      product_name: "Nescafe Classic",
      img: "/assets/images/products/img6.png",
      sub_text: "Price per kg",
      rating: "4.5",
      selling_price: "₹ 120.00",
      mrp: "₹ 150.00",
      discount: "10",
      outOfStock: false,
    },

    {
      product_name: "Nescafe Classic",
      img: "/assets/images/products/img6.png",
      sub_text: "Price per kg",
      rating: "4.5",
      selling_price: "₹ 120.00",
      mrp: "₹ 150.00",
      discount: "10",
      outOfStock: false,
    },
  ];
  const [selectedOption, setSelectedOption] = useState(null);

  const [subCategoryId, setSubCategoryId] = useState(null);

  const location = useLocation();
  const { id } = useParams();
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const queryParams = new URLSearchParams(location.search);
  const searchValue = queryParams.get("search");
  const allProducts = useSelector((state) => state.product.allProducts);
  useEffect(() => {
    dispatch(
      getAllProducts({
        name: searchValue,
        // category_id: id,
        subcategory_id: id,
        priceOrder: selectedOption || "",
        page: currentPage,
      })
    );
  }, [dispatch, id, selectedOption, searchValue, currentPage]);

  const searchParams = new URLSearchParams(location.search);
  const categoryName = searchParams.get("category_name");

  const categoryImage = searchParams.get("category_image");

  const totalPages = Math.ceil(allProducts?.total_pages);

  const handlePageChange = (pageNum) => {
    if (pageNum >= 1 && pageNum <= totalPages) {
      setCurrentPage(pageNum);
    }
  };

  // const paginatedData = allProducts?.slice(
  //   (currentPage - 1) * itemsPerPage,
  //   currentPage * itemsPerPage
  // );
  return (
    <section className="Product_Listing_Page">
      <Tab.Container id="left-tabs-example" defaultActiveKey="Grid">
        <Top_Filter_Div
          pageTitle={categoryName}
          selectedOption={selectedOption}
          setSelectedOption={setSelectedOption}
        />

        <div className="container">
          {/* Show SubCategory Slider only if not searching */}
          {!searchValue && (
            <All_Vegitables_subCategory_Slider
              categoryImage={categoryImage}
              categoryId={id}
              show={true}
              setSubCategoryId={setSubCategoryId}
            />
          )}

          <Tab.Content className="mt-5">
            <Tab.Pane eventKey="Grid">
              <div className="row">
                {allProducts?.data?.length > 0 ? (
                  allProducts?.data?.map((product) => {
                    if (
                      subCategoryId === product?.p_sub_category_id ||
                      subCategoryId === null
                    ) {
                      return (
                        <div
                          key={product.id}
                          className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12 mb-5 custom_col"
                        >
                          <Product_Info_Grid_View product={product} showQty />
                        </div>
                      );
                    }
                    return null;
                  })
                ) : (
                  <div
                    style={{
                      textAlign: "center",
                      padding: "20px",
                      fontWeight: "bold",
                      width: "100%",
                    }}
                  >
                    Product Not Available
                  </div>
                )}
              </div>
              <div className="pagination mt-4 d-flex justify-content-center align-items-center gap-2">
                <button
                  onClick={() => handlePageChange(1)}
                  disabled={currentPage === 1}
                >
                  &laquo;
                </button>
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  &lsaquo;
                </button>

                {/* Always show first two pages */}
                {[currentPage].map((page) => (
                  <button
                    key={page}
                    onClick={() => handlePageChange(page)}
                    className={page === currentPage ? "active" : ""}
                  >
                    {page}
                  </button>
                ))}
                {/* Show ... if there are more than 3 pages */}
                {totalPages > 3 && (
                  <>
                    <span>...</span>

                    {/* Show last page */}
                    <button
                      onClick={() => handlePageChange(totalPages)}
                      className={currentPage === totalPages ? "active" : ""}
                    >
                      {totalPages}
                    </button>
                  </>
                )}

                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  &rsaquo;
                </button>
                <button
                  onClick={() => handlePageChange(totalPages)}
                  disabled={currentPage === totalPages}
                >
                  &raquo;
                </button>
              </div>
              <div className="shop_banner_holder">
                <Shop_Banner />
              </div>
            </Tab.Pane>
            <Tab.Pane eventKey="List">
              {allProducts?.data?.length > 0 ? (
                allProducts.data?.map((product) =>
                  subCategoryId === product?.p_sub_category_id ? (
                    <Product_Info_List_View
                      key={product.id}
                      products={product}
                      showQty
                    />
                  ) : subCategoryId === null ? (
                    <Product_Info_List_View
                      key={product.id}
                      products={product}
                      showQty
                    />
                  ) : null
                )
              ) : (
                <div
                  style={{
                    textAlign: "center",
                    padding: "20px",
                    fontWeight: "bold",
                  }}
                >
                  Product Not Available
                </div>
              )}
            </Tab.Pane>
          </Tab.Content>
        </div>
      </Tab.Container>
    </section>
  );
};

export default Product_Listing_Page_SubCategory;
